export default __webpack_public_path__ + "static/media/model_diagram.0577d1bd.png";